import React, { useEffect, useState } from 'react'
import LogoNevula from '../assets/images/logo-nevula.svg'
import Button from '../components/General/Button'
import { useHistory, useLocation } from 'react-router-dom'
import jwtDecode from 'jwt-decode'
import { AuthService } from '../services/AuthService'
import { useDispatch } from 'react-redux'
import { refreshToken } from '../redux/actions/authentication'

const ExternalLayout: React.FC = ({ children }) => {

  const [windowSize, setWindowSize] = useState(getWindowSize());

  const dispatch = useDispatch()

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  function getWindowSize() {
    const {innerWidth, innerHeight} = window;
    return {innerWidth, innerHeight};
  }

  // useEffect(() => {
  //   console.log("window size", windowSize.innerHeight)
  // }, [windowSize])

  const location = useLocation()

  const history = useHistory()

  return (
    <div>
      <div className="flex flex-col items-center bg-white dark:bg-gray-800" style={{minHeight: windowSize.innerHeight - 1}}>
        <div className={`w-full flex items-center flex-nowrap ${ location.pathname.includes("/confirmed-email") ? 'justify-center' : 'justify-between'} py-10 px-14 mt-[-20px]`}>
          <div className="w-52">
            <img src={LogoNevula} alt="zerux" />
          </div>

          {!location.pathname.includes('/ingresar') && !location.pathname.includes("/quinto") && !location.pathname.includes("/forgotpassword") 
          && !location.pathname.includes("/confirmed-email") && (
            <div>
              <Button type="outline" classes="rounded-3xl w-40" onClick={async () => {
                if (location.pathname.includes('/payment/success')) {
                  await dispatch(refreshToken())
                  history.push('/dashboard')
                  return
                }
                history.push("/ingresar")
              }}>
                { location.pathname.includes('/payment/success') ? 'Volver a zerux' : 'Iniciar sesión'}
              </Button>
            </div>
          )}
        </div>
        
        <div className={location.pathname.includes('/confirmed-email') || location.pathname.includes('/payment/success') || location.pathname.includes('/deudor') ? "mt-10" :"shadow-md bg-white dark:bg-black rounded-2xl px-10 py-12 mb-4" }>
          {children}
        </div>
      </div>
    </div>
  )
}

export default ExternalLayout
